import React, { useEffect, useRef, useState } from 'react';
import './index.css';
import { widget } from '../../charting_library/charting_library.min';
import { dataFeedObject } from './Datafeed';

const GREEN_COLOR = '#5cbf8c';
const RED_COLOR = '#e4224a';

function getLanguageFromURL() {
	const regex = new RegExp('[\\?&]lang=([^&#]*)');
	const results = regex.exec(window.location.search);
	return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

const TVChartContainer = ({pair1, pair2, kline, refreshExchange, currentMarket, markets, decimalValue, theme,updateGraph}) => {
	const chartContainerRef = useRef();

	const [hover, setHover] = useState(false);

	const [currentKlineSubscription, setCurrentKlineSubscription] = useState({});

	const dataFeed = dataFeedObject(
		this,
		markets,
		decimalValue,
		currentMarket,
	);

	console.log(dataFeed);

	const defaultProps = {
    symbol:
    pair1 != '' && pair1 != undefined && pair2 != '' && pair2 != undefined && pair2 + pair1,
		interval: '5',
		libraryPath: '/charting_library/',
		chartsStorageUrl: 'https://saveload.tradingview.com',
		chartsStorageApiVersion: '1.1',
		containerId: "tv_chart_container",
		clientId: 'tradingview.com',
		userId: 'public_user_id',
		fullscreen: false,
		autosize: false,
		studiesOverrides: {},
	};

	useEffect(() => {
		const widgetOptions = {
			symbol: defaultProps.symbol,
			// BEWARE: no trailing slash is expected in feed URL
			datafeed: dataFeed,
			interval: defaultProps.interval,
			container: chartContainerRef.current,
			library_path: defaultProps.libraryPath,
			container_id: defaultProps.containerId,
			locale: getLanguageFromURL() || 'en',
			width: "100%",
			height: 300,
			disabled_features: [
				'context_menus',
				'volume_force_overlay',
				'countdown',
				'use_localstorage_for_settings',
				'header_symbol_search',
				'header_indicators',
				'header_chart_type',
				'header_compare',
				'header_saveload',
				'header_screenshot',
				'left_toolbar',
				'display_market_status',
				'timeframes_toolbar',
				'control_bar',
				'adaptive_logo',
				'border_around_the_chart',
				'symbol_info',
				'create_volume_indicator_by_default',
				'show_chart_property_page',
				(!hover) ? 'header_widget' : '',
			],
			enabled_features: [
				'show_animated_logo',
				'hide_left_toolbar_by_default'
			],
			theme: theme,
			charts_storage_url: defaultProps.chartsStorageUrl,
			charts_storage_api_version: defaultProps.chartsStorageApiVersion,
			client_id: defaultProps.clientId,
			user_id: defaultProps.userId,
			fullscreen: defaultProps.fullscreen,
			autosize: defaultProps.autosize,
      overrides: {
        'mainSeriesProperties.showCountdown': true,
        'paneProperties.background': theme === 'dark' ? '#000133' : '#fff',
        // "paneProperties.vertGridProperties.color": "#25324d",
        // "paneProperties.horzGridProperties.color": "#25324d",
        'symbolWatermarkProperties.transparency': 90,
        'scalesProperties.textColor': '#AAA',
        'scalesProperties.bgColor': '#AAA',
        'scalesProperties.fontSize': 11,
        'mainSeriesProperties.candleStyle.upColor': GREEN_COLOR,
        'mainSeriesProperties.candleStyle.downColor': RED_COLOR,
        'mainSeriesProperties.candleStyle.wickUpColor': GREEN_COLOR,
        'mainSeriesProperties.candleStyle.wickDownColor': RED_COLOR,
        'mainSeriesProperties.candleStyle.borderColor': GREEN_COLOR,
        'mainSeriesProperties.candleStyle.borderUpColor': GREEN_COLOR,
        'mainSeriesProperties.candleStyle.borderDownColor': RED_COLOR,
        'mainSeriesProperties.barStyle.upColor': GREEN_COLOR,
        'mainSeriesProperties.barStyle.downColor': RED_COLOR,
        'mainSeriesProperties.barStyle.dontDrawOpen': true,
		'mainSeriesProperties.style':2
      },

      custom_css_url:
        theme === 'dark'
          ? `${process.env.PUBLIC_URL}/charting_library/static/css/header.css`
          : '',
			studies_overrides: defaultProps.studiesOverrides,
		};

		const tvWidget = new widget(widgetOptions);

		return () => {
			tvWidget.remove();
		};
	},[updateGraph]);

	return (
		<div
			id={defaultProps.containerId}
			ref={chartContainerRef}
			className={'TVChartContainer'}
			style={{
				padding: 0,
				margin: 0,
				height: "250px"
			}}
			
		/>
	);
}

export default TVChartContainer;